export const RESET_PASSWORD_TOKEN_LIFETIME = 120;

export const formatResetPasswordTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
};

export const getPasswordStyle = (password: string) => {
  const hasLetters = /[a-zA-Z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChars = /\W/.test(password);
  const length = password.length;

  if (length < 10 || !hasLetters || !hasNumbers) {
    return { borderColor: 'red', borderWidth: '2px' };
  }
  if (length >= 10 && length < 12 && (!hasSpecialChars || !hasUpperCase)) {
    return { borderColor: '#fff566', borderWidth: '3px' };
  }
  if (length >= 12) {
    return { borderColor: 'green', borderWidth: '2px' };
  }

  return { borderColor: '#fff566', borderWidth: '3px' };
};
